module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "itemsblock"
  }, [(_vm.$slots.result) ? _c('div', {
    staticClass: "itemsblock__result"
  }, [_vm._t("result")], 2) : _vm._e(), (_vm.description.length) ? _c('Familiarize', {
    staticClass: "itemsblock__comp",
    attrs: {
      "title": "Ознакомиться:"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })]) : _vm._e(), (_vm.links.length) ? _c('Links', {
    staticClass: "itemsblock__comp",
    attrs: {
      "title": "Ссылки:",
      "links": _vm.links
    }
  }) : _vm._e(), (_vm.files.length) ? _c('Files', {
    staticClass: "itemsblock__comp",
    attrs: {
      "title": "Скачать файлы:",
      "files": _vm.files
    }
  }) : _vm._e(), (_vm.$slots.form) ? _c('div', {
    staticClass: "itemsblock__form"
  }, [_c('Button', {
    staticClass: "itemsblock__btn",
    class: {
      itemsblock__btn_bottom: _vm.openForm
    },
    attrs: {
      "bordered": _vm.openForm
    },
    on: {
      "click": _vm.toggleForm
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), (_vm.openForm) ? [_c('p', {
    staticClass: "itemsblock__description itemsblock__description_bottom"
  }, [_vm._v("Вы можете приложить файл в формате jpg, png, pdf, word. Прислать нам ссылку на файл с результатом теста или написать результат в текстовое поле.")]), _vm._t("form")] : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4946f241","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/itemsblock/ItemsBlock.vue
// module id = 6c5867850f5afaaf9eb9
// module chunks = 89